import React, { useEffect, useState } from "react";
import "./NewLocationins.css";
import HomeService from "../../../Services/HomeService";
import { toast } from "react-toastify";
// import CityOverview from "../CityOverview/CityOverview";
import ReelsPlayer from "../ReelsPlayer/ReelsPlayer";
import NewCityOverview from "./NewCityOverview";

const NewLocationins = () => {

  const [openItem, setOpenItem] = useState(null);
  const [insights, setInsights] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reelsForCity, setReelsForCity] = useState([]);
  const [isReelsPlayerOpen, setIsReelsPlayerOpen] = useState(false);
  const [selectedReel, setSelectedReel] = useState(null);

  /* FETCH INSIGHTS */

  const fetchInsights = async () => {

    setLoading(true);

    try {

      const res = await HomeService?.getPrimeLocationInsights();

      if (res?.status) {
        setInsights(res?.data || []);
      } else {
        toast.error(res?.message);
      }

    } catch (error) {

      console.log(error);
      toast.error("Failed to fetch insights");

    } finally {

      setLoading(false);

    }
  };

  /* FETCH REELS */

  const fetchReelsByCityId = async (id) => {

    if (!id) return;

    try {

      const res = await HomeService.getReelsByCityId(id);

      if (res?.status) {
        setReelsForCity(res?.data?.slice(0, 4));
      }

    } catch (error) {

      console.log(error);

    }
  };

  useEffect(() => {
    fetchInsights();
  }, []);

  /* TOGGLE */

  const toggleItem = async (index, cityId) => {

    if (openItem === index) {

      setOpenItem(null);
      setReelsForCity([]);

    } else {

      setOpenItem(index);
      await fetchReelsByCityId(cityId);

    }
  };

  /* CLOSE VIDEO */

  const handleCloseReelsPlayer = () => {

    setIsReelsPlayerOpen(false);
    setSelectedReel(null);

  };

  if (loading) {

    return (

      <section className="insightx-main-section">

        <div className="insightx-container">

          <div className="insightx-loader-box">

            <div className="spinner-border text-light"></div>

          </div>

        </div>

      </section>

    );
  }

  return (
    <>

      <section className="insightx-main-section">

        {/* BLURS */}

        <div className="insightx-blur-one"></div>
        <div className="insightx-blur-two"></div>

        <div className="insightx-container">

          {/* TOP */}

          <div className="insightx-top-wrapper">

            <span className="insightx-subtitle">
              Prime Locations & Insights
            </span>

            <h2 className="insightx-title">
              Explore Premium Real Estate Markets Across India
            </h2>

            <p className="insightx-description">
              Discover trending investment zones, city growth analytics,
              premium communities and immersive market highlights curated
              for future-ready investors.
            </p>

          </div>

          {/* ACCORDION */}

          <div className="insightx-accordion-wrapper">

            {insights?.map((insight, index) => (

              <div
                className={`insightx-accordion-card ${
                  openItem === index ? "active" : ""
                }`}
                key={index}
              >

                {/* HEADER */}

                <button
                  className="insightx-accordion-header"
                  onClick={() =>
                    toggleItem(index, insight?.city?._id)
                  }
                >

                  <div className="insightx-header-left">

                    <div className="insightx-city-badge">
                      {insight?.city?.name?.charAt(0)}
                    </div>

                    <div className="insightx-city-info">

                      <h3>
                        {insight?.city?.name}
                      </h3>

                      <span>
                        Real Estate Growth Insights
                      </span>

                    </div>

                  </div>

                  <div className="insightx-header-right">

                    <span>
                      Explore
                    </span>

                    <div className="insightx-arrow">

                      <i
                        className={`fa-solid ${
                          openItem === index
                            ? "fa-minus"
                            : "fa-plus"
                        }`}
                      ></i>

                    </div>

                  </div>

                </button>

                {/* BODY */}

                {openItem === index && (

                  <div className="insightx-accordion-body">

                    {/* CITY OVERVIEW */}

                    <div className="insightx-overview-wrapper">

                      <NewCityOverview insight={insight} />

                    </div>

                    {/* REELS */}

                    <div className="insightx-reels-top">

                      <div>

                        <h4>
                          {insight?.city?.name} Highlights
                        </h4>

                        <p>
                          Discover city reels & luxury lifestyle visuals
                        </p>

                      </div>

                    </div>

                    <div className="insightx-reels-grid">

                      {reelsForCity?.length > 0 ? (

                        reelsForCity?.map((e, i) => (

                          <div
                            className="insightx-reel-card"
                            key={i}
                            onClick={() => {
                              setSelectedReel(e);
                              setIsReelsPlayerOpen(true);
                            }}
                          >

                            <img
                              src={e?.thumbnail}
                              alt=""
                            />

                            <div className="insightx-overlay">

                              <div className="insightx-play-btn">

                                <i className="fa-solid fa-play"></i>

                              </div>

                            </div>

                          </div>

                        ))

                      ) : (

                        <div className="insightx-empty-card">

                          <p>
                            No reels available for this city yet.
                          </p>

                        </div>

                      )}

                    </div>

                  </div>

                )}

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* VIDEO MODAL */}

      {isReelsPlayerOpen && selectedReel && (

        <div
          className="insightx-modal-overlay"
          onClick={handleCloseReelsPlayer}
        >

          <div
            className="insightx-modal-content"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="insightx-close-btn"
              onClick={handleCloseReelsPlayer}
            >

              <i className="fa-solid fa-xmark"></i>

            </button>

            <ReelsPlayer
              videoUrl={selectedReel?.video}
              autoPlay={true}
              muted={false}
              controls={true}
              loop={true}
            />

          </div>

        </div>

      )}

    </>
  );
};

export default NewLocationins;